"use strict";

var mergeActions = actionList => {
  var ret = {};

  for (var action of actionList) {
    for (var key of Object.keys(action)) {
      if (ret[key]) {
        ret[key].push(...action[key]);
      } else {
        ret[key] = action[key];
      }
    }
  }

  return ret;
};

module.exports = mergeActions;